import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { u as useQuantumEditor, A as AnnotationToolBarModalComponents } from './AnnotationToolBarModalComponents-4a9cb8d5.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppLabelCountIcon } from './index-b073e388.esm.js';
import { A as AppModal } from './index-9c3f5cad.esm.js';

const AnnotationToolBarAddIcon = _ref => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6;
  let {
    onPress,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _styles = styleGenerator();
  const {
    addNER
  } = useQuantumEditor();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleFirstPress = () => {
    setIsModalVisible(true);
  };
  const handleSubmissionOfNeNER = v => {
    addNER(v);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppModal, {
    isCloseButtonVisible: true,
    transparent: true,
    modalStyle: _styles.modalStyle,
    modalTitle: "Add new",
    isModalVisible: isModalVisible,
    closeModal: () => setIsModalVisible(false),
    barTitleStyle: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.medium_font_size
    },
    rightIconStyle: {
      height: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.medium_font_size,
      width: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.medium_font_size
    },
    leftIconStyle: {
      height: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.medium_font_size,
      width: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.medium_font_size
    }
  }, /*#__PURE__*/React__default.createElement(AnnotationToolBarModalComponents, {
    handleSubmissionOfNeNER: handleSubmissionOfNeNER
  })), /*#__PURE__*/React__default.createElement(AppLabelCountIcon, _extends({}, props, {
    backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.lightGrey,
    label: "ADD NEW",
    labelStyle: {
      fontSize: 20
    },
    data: [],
    icon: "➕",
    onPress: handleFirstPress,
    height: 20,
    width: 25
  })));
};
const styleGenerator = props => StyleSheet.create({
  modalStyle: {
    margin: "auto",
    minHeight: 450,
    maxHeight: 600,
    flexGrow: 0,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center"
  }
});
AnnotationToolBarAddIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AnnotationToolBarAddIcon"
};

export { AnnotationToolBarAddIcon as A };
